import { TextKey } from '@mews-commander/enums';
import { FormInputField, FormInputFieldProps } from '@mews/framework';
import { LockableField } from '../../LockableField';
import { FieldName, WithFieldsConfig } from './types';
import { getFieldLockedConfig } from './helpers';

interface LockableRateInputFieldProps
    extends WithFieldsConfig,
        Omit<FormInputFieldProps, 'name' | 'size' | 'disabled'> {
    name: FieldName;
    onUnlock?: () => void;
}

export const LockableRateInputField = ({ name, fieldsConfig, onUnlock, ...other }: LockableRateInputFieldProps) => (
    <LockableField
        fieldName={name}
        locked={getFieldLockedConfig(name, fieldsConfig)}
        lockedReasonText={TextKey.RatesValuesAreDifferent}
        tooltipTextKey={TextKey.UnlockableRatesField}
        onUnlock={onUnlock}
    >
        {(isLocked) => <FormInputField {...other} name={name} disabled={isLocked} />}
    </LockableField>
);
